import Part from '@/models/VwPartDetails/VwPartDetails';

export default class VwPartDetailsFilter {

	constructor() {
		/*APP_FILTER_DEFINITION*/
		this.partId = '';
		this.notPartId = '';
		this.partNumber = '';
		this.partName = '';
		this.partUom = '';
		this.partDetailId = '';
		this.partClassificationId = '';
		this.partVendorId = '';
		/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
			/*APP_APP_FILTER_CRITERIA*/
			partId: '0',
			partNumber: '0',
			partName: '0',
			partUom: '0',
			partDetailId: '0',
			partClassificationId: '0',
			partVendorId: '0'
			/*END_APP_FILTER_CRITERIA*/
		};
	}

}